export default function isString(
  value: unknown,
  errorMessage = 'Value is not a string',
): asserts value is string {
  if (typeof value !== 'string') {
    throw new Error(errorMessage);
  }
}
